<div class="query-wrapper">

  <!-- minimized -->
  <div *ngIf = "isQueryBuilderMinimized" class = "modal-content small-modal qb-minimized">
              <!--"'Querybuilder.maindiv.header' | translate"-->
        <app-configurable-header
          cdkDragHandle
          [headingText]="'Query'"
          [variant]="'none'"
          [tooltipOne]="expand"
          [iconOne]="'arrow-down'"
          (actionOne)="minimizeQueryBuilder()"
          [tooltipTwo]="'Close'"
          [iconTwo]="'cross'"
          (actionTwo)="closeQueryBuilder()"
          [iconTwoDropdown]="false"
        >
        </app-configurable-header>
  </div>

  <!-- full form -->
  <div *ngIf = "!isQueryBuilderMinimized" class="query-container modal-content small-modal " id="queryDragDiv" cdkDragBoundary=".querybound" cdkDrag [ngResizable]="!isQueryBuilderMinimized" [rzHandles]="'n,e,s,w,se,sw,ne,nw'">

                <!-- [headingText]="'Querybuilder.maindiv.header' | translate"  -->
      <app-configurable-header
        cdkDragHandle
        [headingText]="'Query'"
        [variant]="'none'"
        [tooltipOne]="isQueryBuilderMinimized == false ? minimizeTooltip : expand"
        [iconOne]="isQueryBuilderMinimized == false ? 'arrow-up' : 'arrow-down'"
        (actionOne)="minimizeQueryBuilder()"
        [tooltipTwo]="'Close'"
        [iconTwo]="'cross'"
        (actionTwo)="closeQueryBuilder()"
        [iconTwoDropdown]="false"
      >
      </app-configurable-header>

      <mat-tab-group mat-stretch-tabs disablePagination="true"  class="query-scrollable"> <!--style="max-height: 100%"-->

          <!-- Query Builder -->                <!-- <mat-tab [label]="'Querybuilder.maindiv.buildertab' | translate"> -->
          <mat-tab [label]="'Builder'">
              <!-- <div class="query-builder-heading grey-divider-bottom h6">Add Query</div> -->

              <!-- query builder inputs -->
              <div class="form-content">

                <app-dropdown
                  class="qb-input"
                  [label]="'Querybuilder.buildertab.jointype' | translate"
                  [dropdownList]="joinTypeDropdown"
                  [val]="joinType"
                  (select)="onJoinChange($event)"
                  [isJoinType]="true"
                  [disableJoinTypeDropdown]="disableJoinTypeDropdown"
                >
                </app-dropdown>
                

                <div *ngIf="joinType == 'Distance'" style="height: 48px">
                  <mat-form-field appearance="outline">
                    <mat-label>Within (&#60;=)</mat-label>
                    <input matInput placeholder="Feet" type="number" min="1" id="inputStateDistance" class="form-control query-builder-input" [(ngModel)]="distanceValue" autocomplete="off" />
                  </mat-form-field>
                </div>

                <!-- Layer/Field/Operator selectors -->
                <app-dropdown 
                  [id]="'qbLayerDropdown'"
                  class="qb-input" 
                  [label]="'Querybuilder.buildertab.layer' | translate" 
                  [val]="selectedLayer && (selectedLayer.value ?? null)" 
                  [dropdownList]="layerDropdown" 
                  (select)="onLayerChange($event)"
                > 
                </app-dropdown>
                <app-dropdown class="qb-input" [label]="'Querybuilder.buildertab.field' | translate" [dropdownList]="fieldDropdown" [val]="selectedField" (select)="onFieldChange($event)"> </app-dropdown>
                <app-dropdown class="qb-input" [label]="'Querybuilder.buildertab.operator' | translate" [dropdownList]="operatorDropdown" (select)="operator = $event" [val]="operator"> </app-dropdown>

                <!-- Value - type in -->
                <ng-template [ngIf]="codedValues != null && codedValues.length == 0" class="qb-value-input">
                  <div id="1">   <!--style="width: 220px"-->
                    
                    <!-- date picker -->
                    <ng-template [ngIf]="enableDateTimePicker">
                      <mat-form-field appearance="outline" class="qb-value-input"> <!--style="width: 100%"-->
                        <mat-label>Value</mat-label>
                        <input matInput placeholder="Value" [matDatepicker]="picker" autocomplete="off" [formControl]="codedValueControl" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </ng-template>

                    <!-- basic input -->
                    <ng-template [ngIf]="!enableDateTimePicker" >
                      <mat-form-field appearance="outline" class="qb-value-input"> <!--style="width: 100%"-->
                        <mat-label>Value</mat-label>
                        <input matInput placeholder="Value" autocomplete="off" [formControl]="codedValueControl"/>
                      </mat-form-field>
                    </ng-template>
                  </div>
                </ng-template>

                <!-- Value - select from list  -->
                <ng-template [ngIf]="codedValues != null && codedValues.length > 0">
                  <div id="2" class="can-shrink"> <!--style="width: 220px"-->
                    <mat-form-field appearance="outline" class="qb-value-input" > <!-- style="width: 100%"-->
                      <mat-label>{{ "Querybuilder.buildertab.value" | translate }}</mat-label>
                      <input matInput [matAutocomplete]="auto" [formControl]="codedValueControl"  class="qb-value-input" />
                      <mat-autocomplete #auto="matAutocomplete"  class="qb-value-input">
                        <mat-option *ngFor="let item of filteredOptions | async" [value]="item.code">
                          <span style="color: #000000"
                            ><strong>{{ item.code }}</strong></span
                          >
                          <span>&nbsp;&nbsp;&nbsp;</span>
                          <span style="color: #65656d"
                            ><small>{{ item.name }}</small></span
                          >
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </ng-template>

                <!-- Add/Edit (save) button -->
                <button mat-button style="margin-top: 0; margin-bottom: 18px" class="qb-input-button h7" (click)="editItem()" *ngIf="isRowClicked == true; else elseBlock">
                  <mat-icon svgIcon="pencil"></mat-icon>
                  Save
                </button>
                <ng-template #elseBlock>
                  <button style="margin-top: 0; margin-bottom: 18px" mat-button class="qb-input-button h7" (click)="addItem()">
                    <mat-icon svgIcon="plus"></mat-icon>
                    Add
                  </button>
                </ng-template>

              </div>

              
              <!-- Selected Query / Built Criteria -->
              <!-- <div *ngIf="querytableArr != null && querytableArr.length > 0" class="query-builder-heading h6">Listed Queries</div>
              <div *ngIf="querytableArr != null && querytableArr.length > 0" class="criteria-list section-spacing"> -->
              <div style="background-color: #dceeff">
                <div style="display:flex; justify-content: space-between; align-items: end;">
                  <span class="query-builder-heading h6" style="padding-top:10px;">Built Query</span>
                  <!-- <div class="spinner-border map-loader mr-4 mt-2" role="status" *ngIf="loading">
                    <span class="sr-only">Loading...</span>
                  </div> -->
                  <mat-checkbox class="regular" color="primary" [(ngModel)]="chkMapExtent">
                    <span style="font-size: smaller; padding-right: 10px;">{{ "Querybuilder.buildertab.currentmapextent" | translate }}</span>
                  </mat-checkbox>
                </div>


                <div class="criteria-list section-spacing">
                  <div class="criteria" *ngFor="let qt of builtQuery; let i = index" (click)="setClickedRow(i)" [class.active]="i == selectedRow">
                    <div style="min-width: 30px">{{ qt.joinType }}</div>
                    <div>{{ qt.layerDisplay }}</div>
                    <div style="font-weight: bold;">{{ qt.field }}</div>
                    <div style="align-items: center;">{{ qt.operator }}</div>
                    <div style="font-weight: bold; min-width:120px;">{{ qt.value }}</div>
                    <div class="flex-0">
                      <button mat-icon-button class="" (click)="deleteStatement(i)" aria-label="removequery">
                        <mat-icon svgIcon="cross" style="padding-bottom:5px;"></mat-icon>
                        <!--Remove-->
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              <!-- result summary and interaction buttons-->
              <div style="display: flex; justify-content: space-between; ">

                <!-- record counts -->
                <div style="padding-top:3px;">
                  <div *ngFor="let assets of selectedSet" style="padding-left: 16px; "> 
                    <!--<div style="padding-top: 5px;">{{ assets.LayerInfo.tableAlias }}: <b>{{ assets.Data.length }}</b></div>-->
                    {{ assets.LayerInfo.alias }}: <b>{{ assets.Data.length }}</b><br/>
                  </div>
                </div>

                <!-- table view options -->
                <div *ngIf="selectedSet.length > 0 && !sqlViewOnMap" style="display: flex; ">
                  <button mat-button class="qb-small-button xsmall" title="{{ 'Select-tool.icon.tableviewer' | translate }}" (click)="openGridClicked()">
                    <mat-icon svgIcon="table-view-bottom"></mat-icon>
                  </button>
                  <button mat-button class="qb-small-button xsmall" title="{{ 'Select-tool.icon.maintenanceviewer' | translate }}" (click)="openMaintenanceClicked()">
                    <mat-icon svgIcon="table-view-bottom-2"></mat-icon>
                  </button>
                  <button *ngIf="showCardViewForVisualizationLayer == false" mat-button class="qb-small-button xsmall" title="{{ 'Select-tool.icon.cardviewer' | translate }}" (click)="openCardClicked()">
                    <mat-icon svgIcon="table-view-right"></mat-icon>
                  </button>
                  <button *ngIf="showCardViewForVisualizationLayer == true" mat-button class="qb-small-button xsmall" title="{{ 'Select-tool.icon.cardviewer' | translate }}" (click)="openCardClicked()" data-forTab="yes" id="visualizationResultCard">
                    <mat-icon svgIcon="table-view-right"></mat-icon>
                  </button>
                </div>

              </div>


              <!-- Query Save/Manage Section -->
              <!-- <div class="query-builder-heading h6 grey-divider-bottom">Query Management</div> -->
              <div class="query-builder-heading h6" (click)="showSaveTools = !showSaveTools">Save</div> <!--grey-divider-bottom -->
              <div *ngIf="showSaveTools" style="display:flex; flex-wrap: wrap;">
                 <div class="form-content section-spacing"> 

                    <!-- open saved query -->
                    <div class="form-element">
                      <mat-form-field appearance="outline">
                        <!-- <mat-label>{{ "Querybuilder.buildertab.selectquery" | translate }}</mat-label> -->
                        <mat-label>Open Saved Query</mat-label>
                        <mat-select [(ngModel)]="selectedLoadFile" (ngModelChange)="onFileNameChange($event, 'QB')">
                          <mat-option [value]="fileObj.fileName" *ngFor="let fileObj of savedQueriesList">
                            {{ fileObj.fileName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div style="display: flex; flex-wrap: wrap; ">
                      <!-- save query name -->
                      <div class="form-element">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ "Querybuilder.buildertab.queryname" | translate }}</mat-label>
                          <input matInput [(ngModel)]="fileName" class="qb-value-input"/>
                        </mat-form-field>
                      </div>
                      <!-- save query button -->
                      <div *ngIf="currentUser.soultionTiers[0][0].query_Actions && clickedOnSave" class="form-element">
                        <mat-icon (click)="saveQuery('QB')" class="pointer" svgIcon="save"></mat-icon>
                      </div>
                      <!-- delete query button -->
                      <div *ngIf="currentUser.soultionTiers[0][0].query_Actions" class="form-element">
                        <mat-icon (click)="deleteQuery('QB')" class="pointer" svgIcon="delete"></mat-icon>
                      </div>
                      <!-- import query -->
                      <div *ngIf="currentUser.soultionTiers[0][0].share_Queries" class="form-element">
                        <input type="file" (change)="loadTextAsQuery($event)" style="display: none" #queryUpload aria-label="select file" />
                        <button mat-button class="qb-small-button xsmall" (click)="queryUpload.click()">
                          <mat-icon svgIcon="download"></mat-icon>
                          <span class="button-text">Import</span>
                        </button>
                      </div>
                      <!-- export query -->
                      <div class="form-element">
                        <!-- <button mat-button class="qb-small-button xsmall" (click)="saveQueryAsFile()"> -->
                        <button mat-button (click)="saveQueryAsFile()">
                          <mat-icon svgIcon="share" style="min-height:10px;"></mat-icon>
                          Export
                          <!-- <span class="button-text">Export</span> -->
                        </button>
                      </div>
                    </div>

                  </div>
                </div>

              </mat-tab>
          
          <!-- Predefined Queries -->           <!-- <mat-tab [label]="'Querybuilder.maindiv.predefinedtab' | translate"> -->
          <mat-tab [label]="'Predefined'">
            <mat-radio-group class="predefined-query-group">
              <mat-radio-button color="primary" class="example-radio-button" class="xsmall" (change)="selectPredefinedQuery($event, query)" *ngFor="let query of predefinedQueriesList" [value]="query">
                {{ query.queryDescription }}
              </mat-radio-button>
            </mat-radio-group>
            <!-- <div class="action-items">
              <button type="button" mat-button class="h7 add-button execute-button short-button" (click)="buildQuery()">{{ "Querybuilder.predefinedquery.execute" | translate }}</button>
              <button type="button" mat-button class="h7 add-button short-button" (click)="clearPredefinedtable()">{{ "Querybuilder.predefinedquery.clear" | translate }}</button>
            </div> -->
          </mat-tab>

          <!-- Query Creator -->
          <mat-tab *ngIf="currentUser.soultionTiers[0][0].query_Creator" [label]="'Querybuilder.maindiv.querycreatortab' | translate">
            <div>
              <div class="container">
                <form>
                  <div class="form-row">
                    <div class="form-group col-12">
                      <label for="exampleFormControlTextarea1">{{ "Querybuilder.predefinedquery.queryentry" | translate }}</label>
                      <textarea class="form-control" id="exampleFormControlTextarea1" rows="5" style="font-size: 14px" name="query_created" [(ngModel)]="createdQuery" (change)="onTextAreaChange($event)"></textarea>
                    </div>
                    <div *ngIf="sqlResultCount > 0" class="col-4 my-1 mr-sm-2" style="color: green; position: relative; float: right">
                      <label>{{ "Querybuilder.predefinedquery.totalresultavail" | translate }} : {{ sqlResultCount }}</label>
                    </div>
                    <div class="form-group col-12 mt-3 mb-3">
                      <div class="d-flex justify-content-start">
                        <select id="inputState" style="width: 150px" class="form-control mr-2 query-builder-input" name="allSavedFiles" [(ngModel)]="selectedLoadFile" (ngModelChange)="onFileNameChange($event, 'QC')">
                          <option [value]="''">{{ "Querybuilder.predefinedquery.selectquery" | translate }}</option>
                          <option *ngFor="let fileObj of sqlgetSavedQueries">
                            {{ fileObj.fileName }}
                          </option>
                        </select>
                        <input
                          type="text"
                          style="width: 150px"
                          class="form-control mr-2 query-builder-input"
                          placeholder="{{ 'Querybuilder.buildertab.queryname' | translate }}"
                          id="saveFile"
                          name="saveFileName"
                          [(ngModel)]="fileName"
                          aria-label="File Name"
                        />
                        <button type="button" class="btn btn-secondary mr-2 query-builder-input" (click)="vaildateQuery()" [disabled]="clickedValidate">
                          {{ "Querybuilder.predefinedquery.validate" | translate }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary mr-2 query-builder-input"
                          (click)="runQuery()"
                          *ngIf="createdQuery != null && createdQuery != '' && queryValidatedFromServer == true"
                          [disabled]="clickedRun"
                        >
                          {{ "Querybuilder.predefinedquery.run" | translate }}
                        </button>
                        <button type="button" class="btn btn-secondary mr-2 query-builder-input" *ngIf="createdQuery != null && createdQuery != ''" (click)="clearQuery()">
                          {{ "Querybuilder.buildertab.clear" | translate }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary mr-2 query-builder-input"
                          *ngIf="createdQuery != null && createdQuery != '' && queryValidatedFromServer == true && clickedOnSave"
                          (click)="saveQuery('QC')"
                        >
                          {{ "Querybuilder.predefinedquery.save" | translate }}
                        </button>
                        <button type="button" class="btn btn-primary mr-2 query-builder-input" *ngIf="createdQuery != null && createdQuery != ''" (click)="deleteQuery('QC')">
                          {{ "Querybuilder.predefinedquery.delete" | translate }}
                        </button>
                        <div class="spinner-border map-loader mr-4 mt-2" role="status" *ngIf="loadingQc">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group ml-2">
                      <div class="col-4 custom-control custom-checkbox my-1 mr-sm-2" style="display: inline">
                        <input type="checkbox" class="custom-control-input" id="exportResultsToCSV" name="excelView" [(ngModel)]="sqlViewOnExcel" />
                        <label class="custom-control-label" for="exportResultsToCSV">{{ "Querybuilder.predefinedquery.exportcsv" | translate }}</label>
                      </div>
                      <div class="col-4 custom-control custom-checkbox my-1 mr-sm-2" style="display: inline">
                        <input type="checkbox" class="custom-control-input" id="loadReturnedAssetsInSMS" name="mapView" [(ngModel)]="sqlViewOnMap" />
                        <label class="custom-control-label" for="loadReturnedAssetsInSMS">{{ "Querybuilder.predefinedquery.loadreturnedassets" | translate }}</label>
                      </div>
                      <div style="font-size: 19px">
                        <fa-icon [icon]="faInfoCircle" (click)="InfoMessage()"></fa-icon>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </mat-tab>

      </mat-tab-group>

      <!-- Footer -->
      <div class="sms-form-footer show-drag-corner">
          <div style="padding-top:5px; padding-right:20px;">
            <div class="spinner-border map-loader mr-4 mt-2" *ngIf="loading" role="status" >  
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <button (click)="cleartable()" class="primary-button" mat-button>{{ "Querybuilder.buildertab.clear" | translate }}</button> <!-- add-button h7-->
          <button (click)="buildQuery()" class="primary-button" mat-button>{{ "Querybuilder.buildertab.query" | translate }}</button>
          <button
              *ngIf="currentUser.soultionTiers[0][0].export_Query_Results && showCardViewForVisualizationLayer == false"
              [disabled]="selectedSet.length <= 0 || builtQuery.length <= 0"
              class="inverse-button"
              data-target="#exampleModalCenter1"
              mat-stroked-button
              data-toggle="modal"
          >
              {{ "Querybuilder.buildertab.report" | translate }}
          </button>
          <button *ngIf="currentUser.soultionTiers[0][0].export_Query_Results && showCardViewForVisualizationLayer == true" class="add-button h7" data-target="#exampleModalCenter1" mat-button data-toggle="modal">
              {{ "Querybuilder.buildertab.report" | translate }}
          </button>
      </div>

      <!-- Export Modal -->
      <div class="modal fade bd-example-modal-lg" id="exampleModalCenter1" tabindex="-1" role="dialog" aria-label="exampleModalCenterTitle1" aria-hidden="true" data-backdrop="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content export-modal">
            <app-configurable-header aria-label="Close" [headingText]="'Export'" [variant]="'none'" [iconOne]="'cross'" [tooltipOne]="'Close'" data-dismiss="modal"> </app-configurable-header>
            <div *ngIf="selectedSet.length > 0 || selectedLayer?.isVisualizationLayer == true" class="modal-body">
              <div class="export-form"> 
                <!-- TSDRSAM-1805 report name was not displaying in the dropdown -->
                <app-dropdown [label]="'Querybuilder.exportreport.reportname' | translate" [isQueryReport]="true" [dropdownList]="reportValueDropdown" [val]="reportTypeES" (select)="onChangeReportType($event)"> </app-dropdown>
                <app-dropdown [label]="'Querybuilder.exportreport.format' | translate" [isQueryReportFormat]="true" [dropdownList]="reportFormatDropdown" [val]="reportFormatES" (select)="onChangeReportFormat($event)">
                </app-dropdown>
              </div>
            </div>
            <div class="action-items">
              <button mat-button class="add-button h7" (click)="exportReports()" *ngIf="selectedSet.length > 0 || selectedLayer?.isVisualizationLayer == true">
                <mat-icon svgIcon="share"></mat-icon>
                <span class="button-text">Export</span>
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>

</div>